// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margins {
  margin-left: 8px;
  z-index: 90000;
}

.bottom-margin {
  margin-bottom: 5px;
}

.button-margin-right {
  margin-right: 2px;
}

.label-width {
  white-space: pre-wrap;
  width: 160px;
  padding-top: 18px;
}

.custom-control {
  padding-left: 0 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
